import React from "react";
import {calcResource, lgSetup} from "../../backend/LgSetup";

export function Home() {
    return (

        <div>
            <ul>
                <li><a href="https://duoclassico.eu/celloleads-ru?utm_content=Paris&lng=ru">PARIS RU</a></li>
                <li><a href="/tilda/cello-lg-router?frameid=testframe">CELLO FOOTER</a></li>
            </ul>
            <br/>
            <table><tbody>
                {Object.values(lgSetup.products).map(product => {
                        let image = calcResource(product["path"], product["miniposterResource"])
                        return <tr key={product.productCode}>
                            <td>
                                {product.desc}
                            </td>
                            <td>
                                <a href={"begin?productCode=" + product.productCode + "&lng=ru"}>{product.productCode}</a>

                            </td>
                        </tr>
                    }
                )}
            </tbody></table>
            <br/>
            <ul>
                <li><a href="/unsubscribe">UNSUBSCRIBE</a></li>
                <li><a href="/leadgen?productCode=LRRH-LG-LEAD&lng=ru">LRRH</a></li>
                <li><a href="https://duoclassico.eu/cello202305?local=true">CELLO HOME</a></li>
                <li><a href="begin?productCode=CELLO2023-2023.05.09_JÕHVI-FIXED-PRICE&lng=ru&key2=123A1000A1000A46">Fixed Discount</a></li>
                <li><a href="begin?productCode=CELLO2023-2023.05.09_JÕHVI-FIXED-PRICE&lng=et&utm_source=lg&utm_campaign=CELLO2023.C1.PURCHASE.Test&utm_medium=COLD.ESTONIA.ANY.ANY.S1-All&utm_content=CELLO2023-UNKNOWN.A1.Poster">Fixed ET</a></li>
                <li><a href="begin?productCode=CELLO2023-2023.05.09_JÕHVI-FIXED-PRICE&lng=ru&key2=123A1000A1000A46&abTest1=NextPageA">Fixed Discount</a></li>
                <br/>
                <li><a href="begin?productCode=EU2023-2023.05.25_KARLSRUHE-FIXED-PRICE-1&lng=ru&key2=123A100A00A46">RU</a></li>
                <li><a href="begin?productCode=EU2023-2023.05.25_KARLSRUHE-FIXED-PRICE-1&lng=et&key2=123A100A00A46">ET</a></li>
                <li><a href="begin?productCode=EU2023-2023.05.25_KARLSRUHE-FIXED-PRICE-1&lng=de&key2=123A100A00A46">DE</a></li>
                <li><a href="begin?productCode=EU2023-2023.05.25_KARLSRUHE-FIXED-PRICE-1&lng=fr&key2=123A100A00A46">FR</a></li>
                <li><a href="begin?productCode=EU2023-2023.05.25_KARLSRUHE-FIXED-PRICE-1&lng=nl&key2=123A100A00A46">NL</a></li>
                <li><a href="begin?productCode=EU2023-2023.05.25_KARLSRUHE-FIXED-PRICE-1&lng=uk&key2=123A100A00A46">UK</a></li>
                <li><a href="begin?productCode=EU2023-2023.05.25_KARLSRUHE-FIXED-PRICE-1&lng=en&key2=123A100A00A46">EN</a></li>
                <br/>
                <li><a href="begin?spKeyRedim=SHARE50&skin=&productCode=TEST_CONCERT-2030_01_01_MUSTPEAD-SHARED-DISCOUNT&lng=ru&customerEmail=aleksei.bljahhin@gmail.com&utm_campaign=unknown&utm_content=unknown&utm_medium=unknown&utm_brand=goToPage&utm_source=unknown&referenceId=b3aa61c5-5657-4c92-8f95-69393786aa9e">RedimEN</a></li>
                <li><a href="begin?spKeyRedim=SHARE100&utm_source=&utm_medium=&utm_campaign=&utm_content=&utm_brand=&referenceId=1ccedbd8-d11d-47de-99ea-12f7d9f35794&message=&skin=&productCode=TMF2023-2023.06.30_TARTU_INV-FIXED-PRICE">RedimRU</a></li>

            </ul>
        </div>
    );
}
